import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function Header({ title, highlight, subtitle, icon, short, small = false }) {
  let highlightWords = [];
  if (highlight) {
    if (Array.isArray(highlight)) {
      highlightWords = highlight;
    } else if (typeof highlight === "string") {
      highlightWords = highlight
        .split(",")
        .map((word) => word.trim())
        .filter(Boolean);
    }
  }

  let regexPattern = null;
  if (highlightWords.length > 0) {
    const escapedWords = highlightWords.map((word) => escapeRegExp(word));
    regexPattern = new RegExp(`(${escapedWords.join("|")})`, "gi");
  }

  let processedTitle = title.replace(/\\n|\r?\n/g, "<br />");

  if (regexPattern) {
    processedTitle = processedTitle.replace(regexPattern, `<span>$1</span>`);
  }

  return (
    <div
      className={classNames("acoris__header", {
        "acoris__header--small": small,
      })}
    >
      {icon && <div className="acoris__header--icon">{icon}</div>}
      {subtitle && <div className="acoris__header--subtitle">{subtitle}</div>}
      <div className="acoris__header--row">
        <div
          className="acoris__header--title"
          dangerouslySetInnerHTML={{ __html: processedTitle }}
        />
        {short && <div className="acoris__header--short">{short}</div>}
      </div>
    </div>
  );
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  highlight: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  short: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default React.memo(Header);
